module.exports = __webpack_public_path__ + "static/img/advik-small.1057857.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/students/advik-small.png
// module id = wJUc
// module chunks = 1